<script>
  import footerMenu from './TheFooterMenu';
  import { globalComputed } from "@store/helpers";

  export default {
    components: {
      footerMenu
    },
    data() {
      return {
        aboutMenu: {
          title: '關於零壹',
          list: [
            {
              title: '公司簡介',
              path: {
                name: 'about-zerone'
              }
            },
            {
              title: '經營團隊',
              path: {
                name: 'about-organization'
              }
            },
            {
              title: '零壹大事紀',
              path: {
                name: 'about-history'
              }
            }
          ]
        },
        contactMenu: {
          title: '聯絡我們',
          list: [
            {
              title: '業務洽詢',
              path: {
                name: 'inquiry',
              }
            },
            {
              title: '聯絡銷售人員',
              path: {
                name: 'contactSales',
              }
            },
            {
              title: '營業據點',
              path: {
                name: 'location'
              }
            },
            {
              title: '維修服務',
              path: {
                name: 'repair'
              }
            },

          ]
        },
        InvestorsMenu: {
          title: '投資人專區',
          list: [
            {
              title: '財務資訊',
              path: {
                name: 'investor-finance'
              }
            },
            {
              title: '公司治理',
              path: {
                name: 'investor-companypolicy'
              }
            },
            {
              title: '利害關係人專區',
              path: {
                name: 'investor-int'
              }
            },
            {
              title: '股東專欄',
              path: {
                name: 'investor-shareholders'
              }
            },
          ]
        },
        mobileList: [
          {
            list: [
              {
                to: {
                  name: 'event-list',
                },
                title: '課程活動',
                alias: 'event-list',
                icon: `<i class="icomoon icon-gray-calender"></i>`
              },
              {
                to: {
                  name: 'home',
                },
                title: '首頁',
                alias: 'home',
                icon: `<i class="icomoon icon-white-logo icon"></i>`
              },
              {
                to: {
                  name: 'news-category',
                  params: {
                    categoryAlias: 'promotion'
                  }
                },
                title: '最新消息',
                alias: 'news-category',
                icon: `<i class="icomoon icon-gray-news"></i>`
              },
            ]
          },
          {
            list:[
              {
                to: {
                  name: 'video-list',
                },
                title: '影音專區',
                alias: 'video-list',
                icon: `<i class="icomoon icon-gray-video"></i>`
              },
              {
                to: {
                  name: 'contact-menu',
                },
                title: '聯絡我們',
                alias: 'contact-menu',
                icon: `<i class="icomoon icon-gray-contact"></i>`
              },
              {
                to: {
                  name: 'product-list',
                },
                title: '代理產品',
                alias: 'product-list',
                icon: `<i class="icomoon icon-gray-product"></i>`
              },
            ]
          }
        ],
        isMobileMenuOpen: false,
      }
    },
    computed: {
      ...globalComputed,
      foramtLineId() {
        return (this.currentSetting.lineId || '').replace('@', '')
      },
      formatMobileList() {
        const result = [...this.mobileList]
        if(!this.isMobileMenuOpen) {
          result.length = 1
        }
        return result
      },
      isDetailPage() {
        const detailPageList = [
          'solution-item',
          'product-item',
          'news-item',
          'case-item',
          'video-item',
          'brand-solution-item',
          'brand-product-item',
          'brand-news-item',
          'brand-case-item',
          'brand-video-item',
        ];
        return detailPageList.includes(this.$route.name)
      },
      isMemberPage() {
        const memberPageList = [
          'member-info',
          'member-event-list',
          'member-coupon-list',
          'member-activity-list',
          'member-setting',
        ];
        return memberPageList.includes(this.$route.name)
      },
      webInfoMenu() {
        return {
          title: '網站資訊',
          list: [
            {
              title: '網站地圖',
              path: {
                name: 'site-map'
              }
            },
            // {
            //   title: '訂閱電子報',
            //   path: {
            //     name: 'subscription'
            //   }
            // },
            // {
            //   title: '檔案下載',
            //   path: {
            //     name: 'file'
            //   }
            // },
            // {
            //   title: '常見問答',
            //   path: {
            //     name: 'faq'
            //   }
            // },
            {
              title: '隱私權與服務條款',
              path: {
                name: 'privacy'
              }
            },
            // {
            //   title: '前往IoT網站',
            //   href: this.$globalSubSiteUrl
            // },

          ]
        }
      }
    },
    methods: {
      mobileMenuOpen() {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
        this.$emit('mobileOpen', this.isMobileMenuOpen)
      },
      async tryToLogout() {
        this.loadingLogout = true;
        await this.$store.dispatch('auth/logOut')
          .then(() => {
            this.$router.push({ name: 'home' });
            // if(this.$route.query?.redirectFrom && this.$route.query?.redirectFrom.indexOf(this.$globalSubSiteUrl)) {
            //   window.location = this.$route.query?.redirectFrom
            // } else {
            //   this.$router.push({ name: 'home' });
            // }
          })
          .finally(() => {
            this.loadingLogout = false
          });
      }
    }
  }
</script>
<template>
  <footer :class="$style.footer">
    <div class="container footerBox d-md-block d-none">
      <div class="row">
        <div class="col-lg-5 footerLeft">
          <img src="@assets/images/logo/logo.svg" alt="" width="200">
          <ul class="info list-unstyled">
            <li>零壹科技股份有限公司</li>
            <li>
              地址：
              <a
                href="https://www.google.com.tw/maps/search/台北市內湖路一段360巷8號10樓"
                target="_blank"
                class="info__Item text-decoration-none"
              >
                台北市內湖路一段360巷8號10樓
              </a>
            </li>
            <li>
              電話：
              <a
                href="tel:02-2656-5656"
                class="info__Item text-decoration-none"
              >
                (02)2656-5656
              </a>
            </li>
            <li>
              傳真：
              <a
                href="tel:02-2656-0810"
                class="info__Item text-decoration-none"
              >
                (02)2656-0810
              </a>
            </li>

          </ul>
          <div class="socialMenu">
            <a
              v-if="currentSetting.fbFanpageUrl"
              :href="currentSetting.fbFanpageUrl"
              target="_blank"
              class="text-decoration-none socialMenu__item"
            >
              <i class="fab fa-facebook-square"></i>
              <span class="sr-only">facebook</span>
            </a>
            <a
              v-if="currentSetting.lineId"
              :href="`https://line.me/R/ti/p/%40${foramtLineId}`"
              target="_blank"
              class="text-decoration-none socialMenu__item"
            >
              <i class="fab fa-line"></i>
              <span class="sr-only">line</span>
            </a>
            <a
              v-if="currentSetting.podcast"
              :href="currentSetting.podcast"
              target="_blank"
              class="text-decoration-none socialMenu__item"
            >
              <i class="far fa-podcast"></i>
              <span class="sr-only">podcast</span>
            </a>
            <a
              v-if="currentSetting.youtubeUrl"
              :href="currentSetting.youtubeUrl"
              target="_blank"
              class="text-decoration-none socialMenu__item"
            >
              <i class="fab fa-youtube"></i>
              <span class="sr-only">youtube</span>
            </a>
          </div>
        </div>
        <div class="col-lg-7 footerRight">
          <div class="row">
            <div class="col-md-3 col-6 footerList mb-5 mb-md-0">
              <footerMenu
                :list="aboutMenu"
              />
            </div>
            <div class="col-md-3 col-6 footerList mb-5 mb-md-0">
              <footerMenu
                :list="contactMenu"
              />
            </div>
            <div class="col-md-3 col-6 footerList mb-5 mb-md-0">
              <footerMenu
                :list="InvestorsMenu"
              />
            </div>
            <div class="col-md-3 col-6 footerList mb-5 mb-md-0">
              <footerMenu
                :list="webInfoMenu"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="d-flex flex-column flex-lg-row align-items-center justify-content-center justify-content-lg-between copyright mb-3">
        <div class="left text-center text-md-left mb-md-0 mb-3">© 零壹科技股份有限公司 2024, All Rights Reserved
        </div>
      </div>
    </div>
    <div class="mobile__footerBox fixed-bottom d-md-none d-block">
      <div 
        class="bg-white mobile__footerBox__tableBox"
        :class="{ 'pb-3': isMobileMenuOpen }"
      >
        <table 
          class="table mobile__footerBox__table"
          :class="{ 'hiddenBoder': !isMobileMenuOpen }"
        >
          <tr
            v-for="(listBox,$index) in formatMobileList"
            :key="$index"
          >
            <td
              v-for="(item,$index2) in listBox.list"
              :key="$index2"
              width="33%"
              align="center"
            >
              <router-link
                :to="item.to"
                class="mobile__footerBox__link"
                :class="{ 'isStyleHome': item.alias === 'home', 'isActive': item.alias === $route.name }"
              >
                <div 
                  v-if="item.alias === 'home'" 
                  class="outside"
                >
                  <div 
                    class="mobile__footerBox__icon" 
                    v-html="item.icon"
                  >
                  </div>
                </div>
                <div 
                  v-else 
                  class="mobile__footerBox__icon" 
                  :class="{ 'isActive': item.alias === $route.name }"
                  v-html="item.icon"
                >
                </div>
                <div class="mobile__footerBox__title">{{ item.title }}</div>
              </router-link>
            </td>
          </tr>
        </table>
      </div>
      <div 
        class="mobile__footerBox__openMenu bg-gray-2 pt-1"
        @click="mobileMenuOpen"
      >
        <span class="text-2sm">
          選單 
          <i 
            class="fas fa-caret-down"
            :class="{ 'up': !isMobileMenuOpen }"
          >
          </i>
        </span>
      </div>
      <!-- <div class="row no-gutters">
        <div
          v-for="(item,$index) in mobileList" 
          :key="$index"
          class="col-4 mobile__footerBox__item border"
          :class="{ 'isHomeSyyle': item.alias === 'home' }"
        >
          <BaseButton
            :to="item.to"
            class="isStyleGrayLight isText"
          >
            <span v-html="item.icon"></span>
            <span>{{ item.title }}</span>
          </BaseButton>
        </div>
      </div> -->
      <BaseButton 
        v-if="isDetailPage"
        :to="{ name: 'contact' }" 
        class="isStylePrimary isRadius mobile__footerBox__FixedBtn"
        :class="{ 'active': isMobileMenuOpen }"
      >
        業務洽詢
      </BaseButton>
      <BaseButton 
        v-if="isMemberPage"
        class="isStylePrimary isRadius mobile__footerBox__FixedBtn"
        :class="{ 'active': isMobileMenuOpen }"
        @click="tryToLogout"
      >
        登出
      </BaseButton>
    </div>
  </footer>
</template>
<style lang="scss" module>
  .footer {
    position: relative;
    overflow: hidden;
    font-size: 1rem;
    border-top: 3px solid $color-primary;
    // margin-top: 8.125rem;
    // background: rgba($color-primary, 0.02);
    @include max-md {
      margin-top: 5.5rem;
      text-align: center;
    }
    @include max-md {
      margin-top: 0;
    }
    &::before {
      position: absolute;
      right: -50px;
      bottom: 0;
      width: 30%;
      padding-bottom: 29%;
      content: '';
      background-image: url('@assets/images/footer/footer-pattern.svg');
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      @include max-md {
        display: none;
      }
    }

    :global {
      .footerLeft {
        @include max-lg {
          margin-bottom: 2rem;
        }
      }

      .footerBox {
        position: relative;
        padding-top: 4.375rem;

        // @include max-lg {
        //   padding-top: 5rem;
        // }
      }

      .info {
        margin-top: 38px;
        line-height: 1.85;
        color: $color-gray-6;

        &__Item {
          margin-left: -5px;
          color: $color-gray-6;
          transition: .3s;

          &:hover {
            color: $color-primary;
          }
        }
      }

      // .socialMenu {
      //   margin-top: 50px;

      //   @include max-md {
      //     margin-top: 20px;
      //   }

      //   &__item {
      //     display: inline-block;
      //     width: 75px;
      //     height: 75px;
      //     font-size: 24px;
      //     line-height: 75px;
      //     color: $color-primary;
      //     text-align: center;
      //     letter-spacing: 0;
      //     border: 1px solid $color-primary;
      //     border-radius: 50%;
      //     transition: .3s;

      //     &:not(:last-child) {
      //       margin-right: 40px;
      //     }

      //     &:hover {
      //       color: #FFF;
      //       background-color: $color-primary;
      //     }

      //     @include max-md {
      //       width: 50px;
      //       height: 50px;
      //       font-size: 18px;
      //       line-height: 50px;
      //     }
      //   }
      // }

      .copyright {
        margin-top: 5.5625rem;
        margin-bottom: 2.375px;

        @include max-lg {
          margin-top: 5rem;
        }

        .left {
        }

        .right {
          color: $color-gray-6;
          letter-spacing: 0;

          .link {
            color: black;
            transition: .3s;

            &:hover {
              color: $color-primary;
            }
          }
        }
      }
    }
    @include max-md {
      border-top: 0;
      margin-top: 8.625rem;
      :global {
        .mobile__footerBox {
          box-shadow: 0px -2px 5px #F5F5F4;
          &__tableBox {
              padding: 14px 10px 0 10px;
          }
          &__table {
            border-collapse: collapse;
            position: relative;
            margin-bottom: 0;
            &.hiddenBoder {
              td {
                border: 0;
              }
            }
            td {
              padding-top: 1.5rem;
              padding-bottom: 1.5rem;
              border: 1px solid $color-gray-3; 
            }
            tr:first-child td {
              border-top: 0;
              padding-top: 0;
            }
            tr td:first-child {
              border-left: 0;
              // padding-left: 0;
              // padding-right: 0;
            }
            tr:last-child td {
              border-bottom: 0;
              padding-bottom: 0.75rem;
            }
            tr td:last-child {
              border-right: 0;
              // padding-left: 0;
              // padding-right: 0;
            }
            &:before {
              content: '';
              position: absolute;
              height: 63px;
              width: 63px;
              top: -24px;
              left: 50%;
              transform: translateX(-50%);
              box-shadow: 0px -2px 5px #F5F5F4;
              border-radius: 50%;
              z-index: -1;
            }
            &:after {
              content: '';
              position: absolute;
              height: 50px;
              width: 73px;
              top: -14px;
              left: 50%;
              transform: translateX(-50%);
              background: #fff;
              z-index: -1;
            }
          }
          &__link {
            color: #B1BACA;
            text-decoration: none;
            &:hover {
              color:$color-primary;
              text-decoration: none;
              .mobile__footerBox__icon i:before{
                color:$color-primary;
              }
            }
            &.router-link-exact-active, &.isActive  {
              color:$color-primary;
            }
            &.isStyleHome {
              
              .outside {
                position: relative;
                margin: -24px auto 0 auto;
                height: 63px;
                width: 63px;
                border-radius: 50%;
                background: #fff;
                display: flex;
                align-items: center;
                
              }
              .mobile__footerBox__icon {
                background: $color-primary;
                width: 49px;
                height: 49px;
                line-height: 49px;
                margin: 0 auto;
                border-radius: 50%;
                align-items: center;
                letter-spacing: 0;
                .icon {
                  color: #fff;
                }
              }
              .mobile__footerBox__title {
                margin-top: 1px;
              }
              &:hover {
                color:$color-primary;
                text-decoration: none;
                .mobile__footerBox__icon i:before{
                  color: unset;
                }
              }
            }
          }
          &__icon {
            display: flex;
            justify-content: center;
            font-size: 2.05rem;
            &.isActive {
              i {
                &:before {
                  color: $color-primary;
                }
              }
              .mobile__footerBox__title {
                color: $color-primary;
              }
            }
          }
          &__title {
            margin-top: 8px;
            font-size: 0.8125rem;
          }
          &__openMenu {
            padding-bottom: 1.8rem;
            .up {
              transform: rotate(180deg);
            }
          }
          &__FixedBtn {
            position: fixed;
            bottom: 176px;
            right: 10px;
            width: 60px;
            height: 60px;
            padding: 10px;
            text-align: center;
            white-space: unset;
            font-size: 0.875rem;
            letter-spacing: 0.1em;
            line-height: 1.45;
            &.active {
              bottom: 301px;
            }
          }
        }
      }
    }
  }
</style>
